module.exports = __webpack_public_path__ + "static/img/banner.92ad485.png";


//////////////////
// WEBPACK FOOTER
// ./static/twitter/banner.png
// module id = MdmK
// module chunks = 1